<!-- 添加就诊人 -->
<template>
  <div class="client">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.client {
  width: 100vw;
  height: 100vh;
}
</style>
